import { useRouter, type ErrorComponentProps } from "@tanstack/react-router";
import { useEffect } from "react";
import { Button, Card } from "@magarac/ui";

/**
 * Shown when a screen crashes. Plain words and a way forward (try again, go home, reload);
 * the technical message stays small for when someone sends us a screenshot.
 */
export function ErrorScreen({ error, reset }: ErrorComponentProps) {
  const router = useRouter();
  useEffect(() => {
    console.error("screen error", error);
  }, [error]);
  const detail = error instanceof Error ? `${error.name}: ${error.message}` : String(error);
  return (
    <main className="mx-auto flex min-h-dvh max-w-md flex-col justify-center p-4">
      <Card>
        <h1 className="mb-2 text-xl font-semibold">This screen hit a problem</h1>
        <p className="mb-4 text-muted">
          Nothing you saved is lost. Try again, or go back to Home. If it keeps happening, send us a
          screenshot of this page.
        </p>
        <div className="grid gap-2">
          <Button
            onClick={() => {
              reset();
              void router.invalidate();
            }}
          >
            Try again
          </Button>
          <Button variant="secondary" onClick={() => window.location.assign("/")}>
            Go to Home
          </Button>
        </div>
        <p className="mt-4 break-words text-xs text-muted">{detail}</p>
      </Card>
    </main>
  );
}
